"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _isGranted = _interopRequireDefault(require("../../utils/isGranted"));
var _selectors = require("../../selectors");
;
var Gatekeeper = function Gatekeeper(props) {
  var conditions = props.conditions,
    pass = props.pass,
    fail = props.fail;
  var userPermissions = (0, _reactRedux.useSelector)(_selectors.getUserPermissions);
  var result = (0, _isGranted.default)(userPermissions, conditions);
  return result ? _react.default.Children.only(pass(userPermissions, conditions)) : _react.default.Children.only(fail(userPermissions, conditions));
};
Gatekeeper.displayName = 'Gatekeeper';
Gatekeeper.propTypes = {
  conditions: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  pass: _propTypes.default.func.isRequired,
  fail: _propTypes.default.func.isRequired
};
var _default = Gatekeeper;
exports.default = _default;